<template>
  <div class="z-card pb-0 border-0">
    <h4 class="z-card__title">
      {{ $t('voice.stats.general.block.main') }}
    </h4>

    <div class="z-card__body" style="position: relative">
      <div class="circle-row">
        <div class="circle-row__item circle-row__item--green">
          <span>{{ $t('voice.call.status.answered') }}</span>
          <span>{{ total.answered | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--blue">
          <span>{{ $t('voice.call.status.busy') }}</span>
          <span>{{ total.busy | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--yellow">
          <span>{{ $t('voice.call.status.no_answer') }}</span>
          <span>{{ total.no_answer | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--red">
          <span>{{ $t('voice.call.status.failed') }}</span>
          <span>{{ total.failed | format }}</span>
        </div>

        <stat-total-circle :data="circle_total" :colors="circle_colors">
          <span slot="title">{{ $t('voice.stats.general.field.total') }}</span>
          <span slot="amount">{{ total.total | format }}</span>
        </stat-total-circle>
      </div>

      <column-chart :data="chart_data" :options="chart_options" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ColumnChart from '@shared/components/stats-chart-column';
  import sumBy from 'lodash-es/sumBy';
  import { green, blue, yellow, red } from '@shared/helpers/css';
  import StatTotalCircle from '@shared/components/stats-chart-cicle-total';
  import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: {
      ColumnChart,
      StatTotalCircle
    },

    filters: {
      format: function(val) {
        return parseInt(val).toLocaleString();
      }
    },

    computed: {
      ...mapGetters('voice/stats/general', { items: DATA }),
      chart_options() {
        return {
          series: {
            0: { color: green },
            1: { color: blue },
            2: { color: yellow },
            3: { color: red }
          }
        };
      },
      columns() {
        return [
          '',
          this.$t('voice.call.status.answered'),
          this.$t('voice.call.status.busy'),
          this.$t('voice.call.status.no_answer'),
          this.$t('voice.call.status.failed')
        ];
      },

      chart_data() {
        const values = this.items.map(i => [
          i['group_by'],
          i['answered'],
          i['busy'],
          i['no_answer'],
          i['failed']
        ]);

        return [this.columns, ...values];
      },

      total: function() {
        return {
          answered: sumBy(this.items, 'answered'),
          busy: sumBy(this.items, 'busy'),
          no_answer: sumBy(this.items, 'no_answer'),
          failed: sumBy(this.items, 'failed'),
          total: sumBy(this.items, 'total')
        };
      },

      circle_total: function() {
        return [
          ['', ''],
          ['', this.total.answered],
          ['', this.total.busy],
          ['', this.total.no_answer],
          ['', this.total.failed]
        ];
      },

      circle_colors: function() {
        return [green, blue, yellow, red];
      }
    }
  };
</script>
